// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Zapri',
  error: () => 'Napaka',
  warn: () => 'Opozorilo',
  info: () => 'Informacije',
  confirmation: () => 'Potrditev',
  progressIndeterminate: () => 'V teku',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Med ' + p['FROM_SECTION'] + ' in ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Ni najdenega ujemajočega se odseka.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Za izbiro vrednosti pritisnite tipko Enter.',
  indexer_touchInstructionText: () =>
    'Dvakrat tapnite in zadržite za vstop v način kretenj, nato pa za prilagajanje vrednosti povlecite gor ali dol.',
  inputPassword_show: () => 'Prikaži geslo',
  inputPassword_hide: () => 'Skrij geslo',
  inputPassword_hidden: () => 'Geslo je skrito',
  formControl_clear: () => 'Počisti',
  formControl_loading: () => 'Nalaganje',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimalna dolžina, ki je ' + p['MAX_LENGTH'] + ', je presežena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostali znaki: ' + p['CHARACTER_COUNT'] + '.',
  formControl_requiredMessageDetail: () => 'Vnesite vrednost.',
  select_requiredMessageDetail: () => 'Izberite vrednost.',
  select_noMatchesFound: () => 'Ni ustreznih zadetkov.',
  select_oneMatchFound: () => 'Najden je en zadetek',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Najdeni zadetki: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Najdeni zadetki: ' + p['TOTAL_SIZE'] + ' ali več',
  selectMultiple_selectedValues: () => 'Izbrane vrednosti',
  selectMultiple_showSelectedValues: () => 'Prikažite samo izbrane vrednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izbrane vrednosti: ' + p['VALUE_COUNT'] + '.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Za odstranitev izbrane vrednosti pritisnite tipko Backspace ali Delete.',
  selectMultiple_apply: () => 'Dodeli',
  selectMultiple_back: () => 'Nazaj',
  selector_selected: () => 'Potrditveno polje je označeno',
  selector_unselected: () => 'Potrditveno polje ni označeno',
  userAssistance_learnMore: () => 'Več o tem',
  userAssistance_required: () => 'Zahtevano',
  filePicker_singleFileUploadError: () => 'Naložite po eno datoteko naenkrat',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne morete nalagati datotek tipa ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne morete nalagati datotek tega tipa: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'neznano',
  filePicker_dropzonePrimaryText: () => 'Povlecite in spustite',
  filePicker_dropzoneSecondaryText: () => 'Izberite datoteko ali jo spustite sem',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izberite ali spustite datoteke sem',
  filePicker_addFiles: () => 'Dodaj datoteke',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Povečaj',
  inputNumber_decrease: () => 'Zmanjšaj',
  inputNumber_converterParseError: () => 'Vnesite številko.',
  noData_message: () => 'Ni elementov za prikaz',
  message_navigationFromMessagesRegion: () =>
    'Vstopanje v področje sporočil. Pritisnite F6 za krmarjenje nazaj do elementa, ki je bil v fokusu pred tem.',
  message_navigationToMessagesRegion: () =>
    'Področje sporočil ima nova sporočila. Pritisnite F6 za krmarjenje do najnovejšega področja sporočil.',
  messageToast_allMessagesClosed: () => 'Vsa toast obvestila so zaprta.',
  expandableList_groupCollapse: () => 'Strnjeno',
  expandableList_groupExpand: () => 'Razširjeno',
  expandableList_expandCollapseInstructionText: () =>
    'Za razširitev in strnitev uporabite puščične tipke',
  list_suggestion: () => 'Predlog',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_current: () => 'Trenutno',
  train_visited: () => 'Obiskano',
  train_not_visited: () => 'Ni obiskano',
  train_message_type: () => 'Tip sporočila',
  viz_drillable: () => 'Omogoča vrtanje',
  dataVisualization_stateSelected: () => 'Izbrano',
  dataVisualization_stateUnselected: () => 'Neizbrano',
  dataVisualization_noData: () => 'Ni podatkov za prikaz'
};
export default bundle;
